export default "__VITE_ASSET__9$HYLoSI__"